<template>
  <a-config-provider
    :theme="{
      token: {
        colorPrimary: '#7273F7',
        colorError: '#D54941'
      }
    }"
    :locale="zhCN"
  >
    <router-view />
    <add-workflow
      v-model:open="store.addWorkFlow"
      @asyncSuccess="asyncSuccess"
      :title="typeof store.addWorkFlow === 'object' ? '编辑工作流程' : '新增工作流程'"
    ></add-workflow>
    <share-workflow
      v-model:open="store.shareWorkflow"
      @asyncSuccess="asyncSuccess"
      title="分享工作流程"
    ></share-workflow>
    <auto-running v-model:open="store.autoRunning" @asyncSuccess="asyncSuccess"></auto-running>
    <saveToDatabase
      v-model:open="storeAigc.saveToDatabaseVisible"
      @asyncSuccess="saveToDatabaseSuccess"
    ></saveToDatabase>
  </a-config-provider>
</template>

<script setup>
import { ConfigProvider as AConfigProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { debounce } from 'lodash'
import { setTwoToneColor } from '@ant-design/icons-vue'
import addWorkflow from '@/views/intelligent/components/modal/addWorkflow'
import shareWorkflow from '@/views/intelligent/components/modal/shareWorkflow'
import autoRunning from '@/views/intelligent/components/modal/autoRunning'
import saveToDatabase from '@/views/aiDAM/modal/saveToDatabase.vue'
import { scriptStore } from '@/store/scriptStore'
import { aigcStore } from '@/store/aigcStore'
import { useUploadStore } from '@/store/uploadStore'
import { onMounted, onUnmounted } from 'vue'
import { sessionCache, localCache } from '@/utils/cache'
const store = scriptStore()
const storeAigc = aigcStore()
// 初始化全局上传 store，确保路由切换期间实例常驻
useUploadStore()

dayjs.locale('zh-cn')
setTwoToneColor('#7273F7')

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200)
    super(callback)
  }
}

const asyncSuccess = () => {
  store.addWorkFlow = false
  store.shareWorkflow = false
  store.autoRunning = false
}
const saveToDatabaseSuccess = () => {
  storeAigc.closeSaveToDatabaseModal()
}
const visibilityChangeEvent = () => {
  if (document.hidden) return
  console.log('用户离开了当前标签')
  const sessionTeam = sessionCache.getCache('teamInfo')
  const localTeam = localCache.getCache('teamMessage')

  // 缺少 team 信息时不刷新  避免在登录页/未初始化时误触发 reload
  if (!sessionTeam?.id || !localTeam?.id) {
    if (localTeam?.id) {
      sessionCache.setCache('teamInfo', localTeam)
    }
    return
  }

  if (sessionTeam.id !== localTeam.id) {
    location.reload()
    sessionCache.setCache('teamInfo', localTeam)
  }
}
const handleVisibilityChange = (type) => {
  if (type == 'add') {
    document.addEventListener('visibilitychange', visibilityChangeEvent)
  } else {
    document.removeEventListener('visibilitychange', visibilityChangeEvent)
  }
}
handleVisibilityChange('add')
onMounted(() => {
  handleVisibilityChange('add')
})
onUnmounted(() => {
  handleVisibilityChange('delete')
})
</script>

<style lang="less">
#app {
  background: #fff;
  // background: linear-gradient(180deg, #ebedff -6%, #fcfcff 9%, #fcfcff 24%, #fcfcff 97%);
}
</style>
